// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_aNuWb {
  width: 100%;
  height: 100%;
  background-color: white;
}

.search_Jtvsg {
  padding: var( --size-padMedium );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/group/search/MobileSearchBar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n}\n\n.search {\n  padding: var( --size-padMedium );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_aNuWb`,
	"search": `search_Jtvsg`
};
export default ___CSS_LOADER_EXPORT___;
